export default "__VITE_ASSET__DIkMFmlU__"